import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { QueryPanelState, SubjectGradeInfoResponse } from './models';

const selectQueryPanelState = (state: RootState): QueryPanelState => state.queryPanel;

export const selectSGInfo = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.subjectGradeInfo : null
);

export const selectSystemID = createSelector(
  [selectSGInfo],
  (state: SubjectGradeInfoResponse|null) => state ? state.systemID : null
);

export const selectSGTemplate = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.subjectGradeTemplate : null
);

export const selectIsTemplateCached = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.isTemplateCached : null
);

export const selectQueryPanelIsLoading = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.loading : null
);

export const selectQueryPanelIsloaded = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.loaded : null
);

export const selectQueryPanelsErrMsg = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.errMsg : null
);

export const selectQueryPanelsItemCount = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.itemCount : null
);

export const selectQueryPanelsItemCountLoading = createSelector(
  [selectQueryPanelState],
  (state: QueryPanelState) => state ? state.itemCountLoading : null
);

export const selectYearsInfo = createSelector(
  [selectSGInfo],
  (state: SubjectGradeInfoResponse | null) => state ? state.yearsInfo : null
);

export const selectContentClassificationsList = createSelector(
  [selectSGInfo],
  (state: SubjectGradeInfoResponse | null) =>
    state ? state.contentClassifications && state.contentClassifications.contentClassificationList : null
);

export const selectItemTypes = createSelector(
  [selectSGInfo],
  (state: SubjectGradeInfoResponse | null) => state ? state.itemTypes : null
);

export const selectDifficultyInfo = createSelector(
  [selectSGInfo],
  (state: SubjectGradeInfoResponse | null) => state ? state.difficultyInfo : null
);
